/* eslint-disable max-len */
import React from 'react';
import {
  Box, Typography, Card, CardMedia, CardContent, Button, CardActions,
} from '@mui/material';
import card1 from '../../images/transcript.png';
import card3 from '../../images/caption.jpg';
import card2 from '../../images/translate.png';

const Services = () => (
  <Box id="services" sx={{ width: '100%', padding: { xs: '40px 50px', sm: '60px 100px' }, background: '#F2F7F8' }}>
    <Box sx={{
      width: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
    }}
    >
      <Typography sx={{ width: { xs: '100%', sm: '50%' }, fontWeight: '200', fontSize: { xs: '20px', sm: '30px' } }}>We combine AI and Human professionals To Deliver 99% Accuracy</Typography>
    </Box>
    <Box sx={{
      width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: { xs: '20px', sm: '40px' }, margin: '20px auto',
    }}
    >

      <Card sx={{ maxWidth: '80%' }}>
        <CardMedia
          component="img"
          alt="card"
          height="140"
          image={card1}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            Transcription
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Professionally transcribe all English audio to text, such as interviews, content marketing, video production, and academic research.
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" component="a" href="#pricing">Order</Button>
        </CardActions>
      </Card>
      <Card sx={{ maxWidth: '80%' }}>
        <CardMedia
          component="img"
          alt="card"
          height="140"
          image={card2}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            Translation
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Our intuitive translation platform allows companies of any size to order cost-efficient translations from professional translators.
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" component="a" href="#pricing">Order</Button>
        </CardActions>
      </Card>
      <Card sx={{ maxWidth: '80%' }}>
        <CardMedia
          component="img"
          alt="card"
          height="140"
          image={card3}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            Captions
          </Typography>
          <Typography variant="body2" color="text.secondary">
            We add captions to videos that include the dialogue of your video and important non-verbal elements that set the scene.
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" component="a" href="#pricing">Order</Button>
        </CardActions>
      </Card>

    </Box>
  </Box>
);

export default Services;
